// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProcedureReportProps } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';
import { WorkflowS } from '../../../../Service/WorkflowS';
import { getReportExecutionState } from './reportExecutionState';

const PublishInvoiceReport: FC<ProcedureReportProps> = ({ report }) => {
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { entityId, executionStatus } = report ?? {};
  const executionState = getReportExecutionState(executionStatus);
  const invoiceTransferred = executionState === 'COMPLETED';

  const onClick = () => {
    if (eventId && invoiceTransferred) {
      navigate(`/events/${eventId}/documents/${entityId}`);
    }
  };

  return (
    <Text>
      {executionState === 'SKIPPED' ? 'Übertragung der Rechnung an die Buchhaltung wurde übersprungen.' : null}
      {executionState !== 'SKIPPED' && (
        <>
          <LinkText span onClick={onClick} weight="bolder" disabled={!invoiceTransferred}>
            Rechnung
          </LinkText>{' '}
          {executionState === 'COMPLETED' && 'wurde an die Buchhaltung übertragen.'}
          {executionState === 'PLANNED' && 'wird an die Buchhaltung übertragen.'}
          {executionState === 'NOT_EXECUTED' && 'wurde nicht an die Buchhaltung übertragen.'}
          {WorkflowS.getWorkflowErrorDescription(report)}
        </>
      )}
    </Text>
  );
};

export default PublishInvoiceReport;
